module.exports = __webpack_public_path__ + "static/media/QuincyCatholicAcademy.8a8a6fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/QuincyCatholicAcademy.jpg
// module id = 751
// module chunks = 0